import * as PIXI from 'pixi.js'
window.PIXI = PIXI
PIXI.utils.skipHello()

import 'pixi-spine'

import { Container } from 'pixi.js'
import { APP, RES_CONFIG, RES_FORMAT } from '../../config'
import { pick } from 'lodash'
import * as EventEmitter from 'eventemitter3'
import { min, max } from 'lodash'


export default class BaseScene {
    constructor(itemList = []) {
        this.emitter = new EventEmitter();
        this._scene = new Container();

        this._scene.visible = false;

        // enable zIndex
        this._scene.sortableChildren = true;

        this.items = {}
        this.addResRecursively(this.getScene(), pick(RES_CONFIG, itemList))
    }

    setItemPos(itemName, x, y) {
        this.items[itemName].x = x
        this.items[itemName].y = y
    }

    setItemOnClick(itemName, func) {
        this.setOnClick(this.items[itemName], func);
    }

    setOnClick(node, func) {
        node.interactive = true;
        node.on('mousedown', func);

        let touchStartTs = null
        let touchStartX = null
        let touchList = []
        node.on('touchstart', function() {
            touchStartTs = (new Date()).getTime();
            touchStartX = window.scrollX
            touchList = [touchStartX]
        });
        node.on('touchmove', function() {
            if (touchList.length < 1000000) {
                touchList.push(window.scrollX);
            }
        });
        node.on('touchend', function(e) {
            const isTap = max([ Math.abs(min(touchList) - touchStartX), Math.abs(max(touchList) - touchStartX) ]) < 6
            if ((new Date()).getTime() - touchStartTs < 1000 && isTap) {
                return func(e)
            }
        });
    }

    setItemOverScale(itemName, scaleRate) {
        this.items[itemName].interactive = true;
        this.items[itemName].on('mouseover', () => {
            this.items[itemName].scale.set(this.items[itemName].scale.x * scaleRate, this.items[itemName].scale.y * scaleRate)
        });
        this.items[itemName].on('mouseout', () => {
            this.items[itemName].scale.set(this.items[itemName].scale.x / scaleRate, this.items[itemName].scale.y / scaleRate)
        });
    }

    addResRecursively(parentNode, resConfig) {
        for(const resName in resConfig) {
            let obj = null
            if (resConfig[resName].type === RES_FORMAT.SPRITE) {
                obj = this.createSpriteByName(resName, resConfig)
            } else if (resConfig[resName].type === RES_FORMAT.SPINE) {
                obj = this.createSpineByName(resName, resConfig)
            } else if (resConfig[resName].type === RES_FORMAT.CONTAINER) {
                obj = this.createContainerByName(resName, resConfig)
            }
            if (obj) {
                parentNode.addChild(obj)
                this.items[resName] = obj
                if (resConfig[resName].children) {
                    this.addResRecursively(obj, resConfig[resName].children)
                }
            }
        }
    }

    getScene() { return this._scene }

    show() {
        this._scene.visible = true;
    }

    hide() {
        this._scene.visible = false;
    }

    addToScene(child, name) {
        if (name) {
            child.name = name;
        }
        this.getScene().addChild(child)
    }

    getItemByName(name) {
        return this.getScene().getChildByName(name)
    }

    createSpineByName(name, resConfig = RES_CONFIG, resName) {
        const obj = new window.PIXI.spine.Spine(APP.loader.resources[resName || name].spineData)
        obj.name = name
        obj.config = resConfig[resName || name]
        this.initResByConfig(obj, resConfig)
        return obj
    }
    
    createSpriteByName(name, resConfig = RES_CONFIG, resName) {
        const obj = new window.PIXI.Sprite.from(APP.loader.resources[resName || name].texture)

        // enable zIndex
        obj.sortableChildren = true;

        obj.name = name
        obj.config = resConfig[resName || name]
        this.initResByConfig(obj, resConfig)
        return obj
    }

    createContainerByName(name, resConfig = RES_CONFIG, resName) {
        const obj = new Container()

        // enable zIndex
        obj.sortableChildren = true;

        obj.name = name
        obj.config = resConfig[resName || name]
        this.initResByConfig(obj, resConfig)
        return obj
    }

    initResByConfig(obj) {
        if (obj.config.index) {
            obj.zIndex = obj.config.index
        }
        if (obj.config.scale) {
            obj.scale.set(obj.config.scale[0], obj.config.scale[1])
        }
        if (obj.config.pos) {
            obj.x = obj.config.pos[0]
            obj.y = obj.config.pos[1]
        }
    }

}